import React from 'react';
import Title from '../../../../../@casino/ui/title';
import { useFormik, FormikContext } from "formik";
import makeStyles from '@material-ui/core/styles/makeStyles';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';
import { setPostResultDenomination } from '../../store/thunk/setPostResultDenomination';
import { setPostIssueFrespin } from '../../store/thunk/setPostIssueFreespin';


const useStyles = makeStyles(() => ({
    flex: {
        display: 'flex'
    },
    helper: {
        whiteSpace: 'nowrap',
        overflow: 'visible',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    text: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'visible',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#1c2542',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
    },
    wrapLabel: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: 12,
        marginBottom: 24,
    },
    beginBonusLabel: {
        width: '32%',
    }
}))

const CreateFreespin = () => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const initialValues = {
        game_uuid: '',
        bet_id: '',
        denomination: '',
        total_bet: '',
        player_name: '',
        quantity: '',
        currency: ''
    }

    const getValidation = (values) => {
        const { game_uuid, player_name, currency, quantity, bet_id, total_bet, denomination } = values;
        if (!!!game_uuid || !!!player_name || !!!currency || !!!quantity || (!!!total_bet && (!!!bet_id || !!!denomination))) {
            return false;
        }
        return true;
    }

    const onSubmit = (store) => {
        dispatch(setPostIssueFrespin(store)); 
    }
    

    const formik = useFormik({ onSubmit, initialValues });
    
    return (
        <div style={{ padding: '0 20px' }}>
            <Title label="Создание фриспина" />
            <div style={{
                padding: '20px',
                background: '#1b2039',
                alignItems: 'center',
                borderRadius: '8px',
            }}>
                <FormikContext.Provider value={formik}>
                    <form
                        onSubmit={formik.handleSubmit}
                    >
                        <div className={classes.flex}>
                            <label htmlFor="game_uuid" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                {!formik.values.currency && <span className={classes.helper} style={{ color: 'red' }}>Для того, что бы получить деноминацию выберите сначала валюту</span>}
                                <span className={classes.helper}>Получить деноминацию по игре</span>
                                <input
                                    type="text"
                                    name="game_uuid"
                                    id="game_uuid"
                                    className={classes.text}
                                    value={formik.values.game_uuid}
                                    onChange={(v) => formik.setFieldValue('game_uuid', v.target.value)} />
                            </label>
                            <div style={{ display: 'flex', alignItems: 'center', marginLeft: 20}}>
                                <span style={{
                                    color: formik.values.currency ? 'rgb(36, 38, 62)' : 'rgb(55, 136, 250)',
                                    border: formik.values.currency ? '1px solid rgb(255, 206, 1)' : '1px solid rgb(55, 136, 250)',
                                    background: formik.values.currency ? 'rgb(255, 206, 1)' : 'none',
                                    cursor: formik.values.currency ? 'pointer' : 'auto',
                                    padding: '5px 10px',
                                    marginTop:formik.values.currency ? '8px' : '23px',
                                    overflow: 'hidden',
                                    fontSize: '14px',
                                    maxHeight: '48px',
                                    fontFamily: 'PT Sans, sans-serif',
                                    fontWeight: 400,
                                    userSelect: 'none',
                                    whiteSpace: 'nowrap',
                                    marginRight: '12px',
                                    borderRadius: '16px',
                                    textOverflow: 'ellipsis',
                                    textTransform: 'uppercase',
                                }}
                                    onClick={() => {
                                        if (formik.values.currency) {
                                            dispatch(setPostResultDenomination({
                                                game_uuid: formik.values.game_uuid,
                                                currency: formik.values.currency
                                            })) 
                                        }
                                    }}
                                >Проверить</span>
                            </div>
                        </div>
                        <div style={{ display: 'flex', columnGap: 12 }}>
                            <label htmlFor="bet_id" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Bet id</span>
                                <input
                                    type="text"
                                    name="bet_id"
                                    id="bet_id"
                                    className={classes.text}
                                    value={formik.values.bet_id}
                                    onChange={(v) => formik.setFieldValue('bet_id', v.target.value)} />
                            </label>
                            <label htmlFor="denomination" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Denomination</span>
                                <input
                                    type="text"
                                    name="denomination"
                                    id="denomination"
                                    className={classes.text}
                                    value={formik.values.denomination}
                                    onChange={(v) => formik.setFieldValue('denomination', v.target.value)} />
                            </label>
                            <label htmlFor="total_bet" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Total bet</span>
                                <input
                                    type="text"
                                    name="total_bet"
                                    id="total_bet"
                                    className={classes.text}
                                    value={formik.values.total_bet}
                                    onChange={(v) => formik.setFieldValue('total_bet', v.target.value)} />
                            </label>
                        </div>
                        <div style={{
                            display: 'flex',
                            justifyContent: 'flex-start',
                            columnGap: 12
                        }}>
                            <label htmlFor="player_name" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Логин игрока</span>
                                <input
                                    type="text"
                                    name="player_name"
                                    id="player_name"
                                    className={classes.text}
                                    value={formik.values.player_name}
                                    onChange={(v) => formik.setFieldValue('player_name', v.target.value)} />
                            </label>
                            <label htmlFor="quantity" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Количество</span>
                                <input
                                    type="text"
                                    name="quantity"
                                    id="quantity"
                                    className={classes.text}
                                    value={formik.values.quantity}
                                    onChange={(v) => formik.setFieldValue('quantity', v.target.value)} />
                            </label>

                            <label htmlFor="select" className={clsx(classes.wrapLabel, classes.beginBonusLabel)}>
                                <span className={classes.helper}>Валюта</span>
                                <select style={{height: '34px'}}
                                    className={classes.text}
                                    value={formik.values.currency}
                                    onChange={(v) => formik.setFieldValue('currency', v.target.value)}
                                >
                                    <option value="" style={{ display: 'none' }}>Выбрать валюту</option>
                                    <option value="RUB">RUB</option>
                                    <option value="USD">USD</option>
                                    <option value="EUR">EUR</option>
                                    <option value="GEL">GEL</option>
                                    <option value="TRY">TRY</option>
                                </select>
                            </label>

                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <span style={{
                                color: getValidation(formik.values) ? 'rgb(36, 38, 62)' : 'rgb(55, 136, 250)',
                                border: getValidation(formik.values) ? '1px solid rgb(255, 206, 1)' : '1px solid rgb(55, 136, 250)',
                                background: getValidation(formik.values) ? 'rgb(255, 206, 1)' : 'none',
                                cursor: getValidation(formik.values) ? 'pointer' : 'default',
                                padding: '5px 10px',
                                marginTop: formik.values.currency ? '8px' : '23px',
                                overflow: 'hidden',
                                fontSize: '14px',
                                maxHeight: '48px',
                                fontFamily: 'PT Sans, sans-serif',
                                fontWeight: 400,
                                userSelect: 'none',
                                whiteSpace: 'nowrap',
                                marginRight: '12px',
                                borderRadius: '16px',
                                textOverflow: 'ellipsis',
                                textTransform: 'uppercase',
                            }}
                            onClick={() => {
                                if (getValidation(formik.values)) {
                                    formik.submitForm()
                                }
                            }}
                            >Выдать Freespin</span>
                        </div>
                    </form>
                </FormikContext.Provider>
            </div>
        </div>
    )
}
export default CreateFreespin;
